import moment from 'moment';
import { Button } from '@/components/ui/button';

const getNextBusinessDay = () => {
  const date = moment().add(1, 'day');

  while (date.day() === 0 || date.day() === 6) {
    date.add(1, 'day');
  }

  return date.hour(9).minute(0).second(0);
};

const getOptionLabel = (date, label) => {
  if (label) return label;
  if (date.isSame(moment(), 'day')) return `Today at ${date.format('LT')}`;
  if (date.isSame(moment().add(1, 'day'), 'day')) {
    return `Tomorrow at ${date.format('LT')}`;
  }
  return `${date.format('dddd')} at ${date.format('LT')}`;
};

const QuickScheduleOptions = ({ onSelect, selectedDate, compact = false }) => {
  const now = moment();
  const hour = now.hour();
  const candidates = [];

  if (hour < 9) {
    [9, 12, 15].forEach((scheduledHour) => {
      candidates.push({
        date: now.clone().hour(scheduledHour).minute(0).second(0),
      });
    });
  } else if (hour < 17) {
    candidates.push({
      date: now.clone().add(1, 'hour').startOf('hour'),
    });

    const nextTodaySlot = [12, 15, 17]
      .map((scheduledHour) => now.clone().hour(scheduledHour).minute(0).second(0))
      .find((date) => date.diff(now, 'minutes') >= 90);

    if (nextTodaySlot) candidates.push({ date: nextTodaySlot });
  }

  const tomorrow = now.clone().add(1, 'day');
  candidates.push(
    { date: tomorrow.clone().hour(9).minute(0).second(0) },
    { date: tomorrow.clone().hour(12).minute(0).second(0) },
    { date: getNextBusinessDay() },
    { date: tomorrow.clone().hour(15).minute(0).second(0) },
  );

  const seenTimes = new Set();
  const options = candidates
    .filter(({ date }) => date.diff(now, 'minutes') >= 30)
    .sort((a, b) => a.date.valueOf() - b.date.valueOf())
    .filter(({ date }) => {
      const key = date.format('YYYY-MM-DDTHH:mm');
      if (seenTimes.has(key)) return false;
      seenTimes.add(key);
      return true;
    })
    .slice(0, 3)
    .map((option) => ({
      ...option,
      label: getOptionLabel(option.date, option.label),
    }));

  return (
    <div className={compact ? undefined : 'space-y-2'}>
      {!compact && (
        <p className="text-xs font-medium text-muted-foreground">Quick select</p>
      )}
      <div className={`flex flex-wrap ${compact ? 'gap-1.5' : 'gap-2'}`}>
        {options.map((option) => {
          // Highlight the picked option (filled) so it's obvious which time is set.
          const isSelected =
            selectedDate && moment(selectedDate).isSame(option.date, 'minute');
          return (
            <Button
              key={option.label}
              type="button"
              variant={isSelected ? 'default' : 'outline'}
              size="sm"
              className={compact ? 'h-7 px-2.5 max-md:h-11 max-md:px-3.5' : 'max-md:h-11 max-md:px-3.5'}
              onClick={() => onSelect(option.date.toDate())}
            >
              {option.label}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default QuickScheduleOptions;
